const ColGroupHeader = () => (
    <colgroup>
            <col style={{width: "8%"}}/>
            <col style={{width: "6%"}}/>
            {/* Stocks */}
            <col style={{width: "12.25%"}}/>
            <col style={{width: "5.15%"}}/>
            {/* Today's Gain */}
            <col style={{width: "11.15%"}}/>
            <col style={{width: "4.65%"}}/>
            {/* Overall Gain */}
            <col style={{width: "0.1%"}}/>
            {/* empty */}
            <col style={{width: "11.51%"}}/>
            <col style={{width: "5%"}}/>
            {/* Current Value */}
            <col style={{width: "9.25%"}}/>
            <col style={{width: "5.25%"}}/>
            {/* Quantity */}
            <col style={{width: "8.49%"}}/>
            <col style={{width: "4.05%"}}/>
            {/* Invested */}
            <col style={{width: "1.3%"}}/>
            <col style={{width: "7.85%"}}/>
            {/* Price */}
    </colgroup>
);

export default ColGroupHeader;
